<ng-template [sbmodal]="'mediagroupaddmarkermodal'">
  <sb-custom-modal [templateId]="'mediagroupaddmarkermodal'">
    <div slot="body" style="height: 800px" class="tw-h-[800px]">
      <table class="table">
        <tbody>
        <ng-container *ngIf="possibleMarkers">
          <tr *ngFor="let marker of possibleMarkers">
            <td>{{ marker?.name }}</td>
            <td>{{ marker?.channel?.name }}</td>
            <td *ngIf="!(selectedMarkers.includes(marker))" (click)="addAdSpaceSelection(marker)"
                class="tr cursor-pointer">
              <sb-icon icon="plus"></sb-icon>
            </td>
            <td *ngIf="selectedMarkers.includes(marker)" (click)="removeAdSpaceSelection(marker)"
                class="tr cursor-pointer">
              <sb-icon icon="minus"></sb-icon>
            </td>
          </tr>
        </ng-container>
        <ng-container *ngIf="!possibleMarkers?.length">
          <tr>
            <td><i>{{ 'lang.mediumGroupEdit.noAdSpacesAvailable' | translate }}</i></td>
          </tr>
        </ng-container>
        </tbody>
      </table>
    </div>
    <div slot="footer">
      <button (click)="addAdSpaceClose(selectedMarkers)" class="btn btn-primary">{{
          'lang.globals.submit' |
            translate
        }}
      </button>
    </div>
  </sb-custom-modal>
</ng-template>

<ng-template [sbmodal]="'mediumExplorerModal'">
  <sb-custom-modal [templateId]="'mediumExplorerModal'">
    <div slot="body" class="tw-h-[600px]">
      <sb-page-medium-explorer [modalType]="'groupSelect'" [customer]="mediumGroup?.company"
                               [isInModalContext]="'mediumExplorerModal'"
                               [excludeMedia]="mediumGroup?.media"
                               [selectedResolution]="selectedResolution"></sb-page-medium-explorer>
    </div>
    <div slot="footer" class="tw-h-6">
    </div>
  </sb-custom-modal>
</ng-template>

<sb-button *ngIf="isInModalContext" (click)="showGroupList()" classes="btn-primary ">
  {{ 'lang.mediumGroupEdit.showMotivegroupList' | translate }}
</sb-button>

<div class="row">
  <div class="col-12 col-xl-4">
    <sb-card class="d-flex flex-column flex-sm-row flex-xl-column">
      <div card-img>
        <div style="width: 100%; height: 100%;"
             *ngIf="mediumGroup && mediumGroup?.preview?.contentType && !mediumGroup?.preview?.processing"
             [ngSwitch]="true">
          <sb-comp-medium [medium]="mediumGroup?.preview" [thumbnailSize]="'L'" [title]="true"
                          [customHeight]="'300px'" [customWidth]="'100%'" [showFullOnClick]="true">
          </sb-comp-medium>
        </div>
      </div>
      <div card-body>

        <div class="row">
          <div class="col-12">
            <app-sb-text>
              <ng-container caption>{{ 'lang.globals.motiveGroup' | translate }}</ng-container>
              <input [disabled]="!permissionService.hasPermission(permissionService.Permission.medium_group_edit)" *ngIf="!isInModalContext"
                     type="text" [ngModel]="mediumGroup?.name"
                     (ngModelChange)="mediumGroup.name = $event; editMediumGroup()"
                     class="form-control">
              <ng-container *ngIf="isInModalContext">{{ mediumGroup?.name }}</ng-container>
            </app-sb-text>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <app-sb-text>
              <ng-container caption>
                <sb-icon icon="company"></sb-icon>&nbsp; {{ 'lang.globals.company' | translate }}
              </ng-container>
              {{ mediumGroup?.company?.name }}
            </app-sb-text>
          </div>
          <div class="col-6">
            <app-sb-text>
              <ng-container caption>{{ 'lang.mediumGroupEdit.motivesInGroup' | translate }}</ng-container>
              {{ mediumGroup?.mediaCount }}
            </app-sb-text>
          </div>
        </div>
        <div class="my-2">{{ 'lang.globals.mediumGroupCategory'|translate }}</div>
        <sb-comp-selection [display]="mediumGroup?.category"
                           (selectClicked)="selectCategory()"
                           (createClicked)="createCategory()"
                           (deleteClicked)="deleteCategory()"></sb-comp-selection>
        <hr>
        <!-- attributes -->
        <div
          *ngIf="mediumGroup?.attributes?.length > 0 && permissionService.hasPermission(permissionService.Permission.medium_group_attributes_edit)"
          class="row mb-2">
          <div class="col-12">
            <div class="tw-flex justify-content-between">
              <h5>
                {{ 'lang.globals.attributes'|translate }}
              </h5>
              <button type="button" *ngIf="!attributesEdit" (click)="attributesEdit = !attributesEdit"
                      class="btn btn-hover-primary">{{ 'lang.globals.edit'|translate }}
              </button>
              <button type="button" *ngIf="attributesEdit" (click)="saveAttributes()"
                      class="btn btn-primary">{{ 'lang.globals.save'|translate }}
              </button>
            </div>
            <ng-scrollbar class="mt-2" style="height: 150px; width: 100%" [track]="'vertical'">

              <div *ngFor="let attribute of mediumGroup?.attributes" class="d-flex tw-mr-5 tw-mb-1">
                <p class="w-100">{{ attribute.name }}</p>
                <div class="d-flex justify-content-end w-100">
                  @if (attribute?.datatype?.allowedValues?.length > 0) {
                    <sb-comp-string-dropdown-select
                      class="w-100"
                      [disabled]="!attribute?.datatype?.adPlacerAbleToSet || !permissionService.hasPermission(permissionService.Permission.medium_group_attributes_edit) || !attributesEdit"
                      [singleSelectMode]="false" [showSubmit]="false" [hidePagination]="true"
                      [inputData]="attribute.datatype.allowedValues" [dropDownDatatype]="'ATTRIBUTE'"
                      (selectedDataEmitter)="updateAttribute(attribute, $event)" [showColumnIcon]="false"
                      [showIcon]="false" [frontendSearch]="true"
                      [selectedInputData]="getAttributeInputData(attribute)">
                    </sb-comp-string-dropdown-select>
                  } @else {
                    <input type="text" class="form-control text-right"
                           [disabled]="!attribute?.datatype?.adPlacerAbleToSet || !permissionService.hasPermission(permissionService.Permission.medium_group_attributes_edit)|| !attributesEdit"
                           placeholder="..." [(ngModel)]="attribute.value">
                  }
                </div>
              </div>
            </ng-scrollbar>

          </div>
        </div>
        <hr>
        <div class="row">
          <div class="col-6">
            <app-sb-text>
              <ng-container caption>
                <sb-icon icon="product"></sb-icon>&nbsp; {{ 'lang.globals.products' | translate }}
              </ng-container>
              {{ mediumGroup?.promotedProducts?.length }}
            </app-sb-text>
          </div>
          <div class="row">
            <div class="col-12">
              <hr>
            </div>
          </div>
          <div class="col-6">
            <app-sb-text>
              <ng-container caption>{{ 'lang.globals.products' | translate }}</ng-container>
              <span *ngFor="let product of mediumGroup?.promotedProducts">{{ product?.name }}<br></span>
            </app-sb-text>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <hr>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <ng-container *ngPermissions="permissionService.Permission.medium_group_manage_promoted_products">
              <button *ngIf="!isInModalContext" (click)="addProductToMediumGroup(mediumGroup)" type="button"
                      class="btn btn-hover-primary w-100">
                <sb-icon icon="product"></sb-icon>
                {{ 'lang.globals.assignProduct' | translate }}
              </button>
            </ng-container>
          </div>
          <div class="col-6"
               [class.offset-6]="!permissionService.hasPermission(permissionService.Permission.medium_group_manage_promoted_products)">
            <ng-container *ngPermissions="permissionService.Permission.medium_group_delete">
              <button *ngIf="!isInModalContext" (click)="deleteMediumGroup(mediumGroup)" type="button"
                      class="btn btn-danger w-100">
                <sb-icon icon="trash"></sb-icon>
                {{ 'lang.mediumExplorer.delete' | translate }}
              </button>
            </ng-container>
          </div>
        </div>
        <div class="row">
          <div class="col-12" *ngIf="isInModalContext">
            <button (click)="selectMediumGroup(mediumGroup)" class="btn btn-primary ">
              {{ 'lang.mediumGroupEdit.selectGroup' | translate }}
            </button>
          </div>
        </div>
      </div>
    </sb-card>
    <sb-card class="d-flex flex-column flex-sm-row flex-xl-column" *ngIf="missingMarker?.length > 0">
      <div card-header>
        <div class="red d-flex justify-content-center align-items-center">
          <sb-icon icon="attention"></sb-icon>
          {{ 'lang.globals.warningResolution' | translate }}
        </div>
      </div>
      <div card-fit>
        <table class="table table-hover">
          <thead>
          <tr>
            <th>Name</th>
            <th>Channel</th>
            <th>{{ 'lang.globals.resolution' |translate }}</th>
          </tr>
          </thead>
          <tbody>
          <tr class="cursor-pointer" *ngFor="let missing of missingMarker"
              (click)="addNewMotiveToGroup(missing.resolution)">
            <td><span [innerHTML]="missing?.name | truncate: 30"></span></td>
            <td><span [innerHTML]="missing?.channel?.name | truncate: 30"></span></td>
            <td>{{ missing?.resolution?.id }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </sb-card>
  </div>
  <div class="col-12 col-xl-8">
    <div class="card d-flex flex-column flex-sm-row flex-xl-column tw-border-solid tw-border-sbRed-600 " *ngIf="showTimeDifferenceWarning">
      <h3 class="red d-flex justify-content-center align-items-center tw-p-5">
        <sb-icon icon="attention" class="tw-mr-2"></sb-icon>
        {{ 'lang.motives.durationWarning' | translate }}
      </h3>
    </div>
    <div class="card d-flex flex-column flex-sm-row flex-xl-column tw-border-solid tw-border-sbRed-600 " *ngIf="hasDuplicateResolution">
      <h3 class="red d-flex justify-content-center align-items-center tw-p-5">
        <sb-icon icon="attention" class="tw-mr-2"></sb-icon>
        {{ 'lang.globals.doubleResolution' | translate }}
      </h3>
    </div>
    <div class="row">
      <ng-scrollbar style="width: 100%; height: 105vh;">
        <div class="col-xxl-12 col-xl-12 col-12" *ngFor="let medium of mediumGroup?.media">
          <div *ngIf="medium" class="card mb-4 media-thumb-container overflow-hidden"
               [ngbTooltip]=" duplicateCheck(medium) ? ('lang.globals.doubleResolution'|translate) : durationCheck(medium) ? ('lang.motives.durationWarning'|translate) : ''"
               [ngClass]="{'durationWarning': durationCheck(medium) || duplicateCheck(medium)}">
            <div class="row">
              <div class="col-4 overflow-hidden preview-content">
                <sb-comp-medium [medium]="medium" [still]="true" [thumbnailSize]="'M'" class="list-media-thumbnail responsive border-0"
                                [customHeight]="'225px'" [customWidth]="'100%'"
                                [showFullOnClick]="true"></sb-comp-medium>
              </div>
              <div class="col-8">
                <div class="card-body d-flex flex-column justify-content-between min-width-zero">
                  <div class="row">
                    <div class="col-12 col-xxl-5">
                      <div class="row">
                        <div class="col-12">
                          <app-sb-text>
                            <ng-container caption>
                              {{ 'lang.globals.name' | translate }}
                            </ng-container>
                            <span [innerHtml]=" medium?.name | truncate: 35"></span>
                          </app-sb-text>
                        </div>
                        <div class="col-6">
                          <app-sb-text>
                            <ng-container caption>
                              {{ 'lang.globals.resolution' | translate }}
                            </ng-container>
                            {{ medium?.resolution?.id }}
                          </app-sb-text>
                        </div>
                        <div class="col-6">
                          <app-sb-text>
                            <ng-container caption>
                              {{ 'lang.globals.duration' | translate }}
                            </ng-container>
                            {{ medium?.duration ? medium.duration + 's' : '-' }}
                          </app-sb-text>
                        </div>
                        <div class="col-6">
                          <app-sb-text>
                            <ng-container caption>
                              {{ 'lang.mediumExplorer.fileFormat' | translate }}
                            </ng-container>
                            <div *ngIf="medium?.contentType" [ngSwitch]="true">
                              <sb-icon *ngSwitchCase="medium?.contentType.indexOf('video') !== -1" icon="video"></sb-icon>
                              <sb-icon *ngSwitchCase="medium?.contentType.indexOf('image') !== -1" icon="photo"></sb-icon>
                              <sb-icon *ngSwitchDefault icon="brackets"></sb-icon>
                              <span class="ml-1" [innerHTML]="medium?.contentType | truncate : 12"></span>
                            </div>
                          </app-sb-text>
                        </div>
                        <div class="col-6">
                          <app-sb-text>
                            <ng-container caption>
                              {{ 'lang.globals.status' | translate }}
                            </ng-container>
                            <ng-container>
                              <small *ngIf="!medium?.locked && medium.usageCount === 0" class="red">
                                <sb-icon icon="lockOpen"></sb-icon>&nbsp;&nbsp;{{
                                  'lang.mediumExplorer.notReadyUse' |
                                    translate
                                }}
                              </small>
                              <small *ngIf="medium?.locked && medium.usageCount === 0" class="yellow">
                                <sb-icon icon="lockClosed"></sb-icon>&nbsp;&nbsp;{{ 'lang.mediumExplorer.readyUse' | translate }}
                              </small>
                              <small *ngIf="medium?.locked && medium.usageCount >= 1" class="green">
                                <sb-icon icon="lockClosed"></sb-icon>&nbsp;&nbsp;{{ 'lang.mediumExplorer.inUse' | translate }}
                              </small>
                            </ng-container>
                          </app-sb-text>
                        </div>
                        <div class="col-12">
                          <hr>
                        </div>
                        <div class="col-12">
                          <div class="d-flex justify-content-left w-100">
                            <ng-container *ngPermissions="permissionService.Permission.medium_group_edit">
                              <button ngbTooltip="{{'lang.mediumGroupEdit.setAsPreview' | translate}}" placement="left"
                                      class="btn btn-clean mr-1" container="body"
                                      (click)="setToPreview(medium)" [ngClass]="isPreviewClass(medium)">
                                <sb-icon icon="starFilled"></sb-icon>
                              </button>
                              <sb-button *ngIf="!isInModalContext"
                                         ngbTooltip="{{'lang.mediumGroupEdit.addAdspace' | translate}}" placement="left"
                                         (click)="showMarkerToAdd(medium)" container="body"
                                         classes="btn-primary actionButtonMinWidth mr-1 ml-1">
                                <sb-icon icon="plus"></sb-icon>
                              </sb-button>
                              <sb-button *ngIf="!isInModalContext"
                                         ngbTooltip="{{'lang.mediumGroupEdit.removeMotive' | translate}}"
                                         placement="left" container="body"
                                         (click)="removeMotiveFromGroup(medium)"
                                         classes="btn-secondary actionButtonMinWidth mt-0 ml-1">
                                <sb-icon icon="trash"></sb-icon>
                              </sb-button>
                              <sb-button *ngIf="!isInModalContext"
                                         ngbTooltip="{{'lang.globals.editMedium' | translate}}"
                                         placement="left" container="body"
                                         (click)="showMedium(medium)"
                                         classes="btn-primary actionButtonMinWidth mt-0 ml-1">
                                <sb-icon icon="diveDeeper"></sb-icon>
                              </sb-button>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-xxl-7">
                      <ng-scrollbar style="width: 100%; height: 180px;">
                        <table style="font-size: 16px" class="table table-sm">
                          <thead class="">
                          <tr>
                            <th colspan="3" [ngClass]="{'durationWarning': durationCheck(medium) || duplicateCheck(medium)}">
                              {{ 'lang.mediumGroupEdit.defaultAdspaces' | translate }}
                            </th>
                          </tr>
                          </thead>
                          <tbody>
                          <ng-container *ngIf="medium?.defaultMarkers?.length > 0">
                            <tr *ngFor="let marker of medium?.defaultMarkers">
                              <td [innerHTML]="marker?.name | truncate : 14"></td>
                              <td [innerHTML]="marker?.channel?.name | truncate : 22"></td>
                              <td>
                                <div class="cursor-pointer"
                                     *ngIf="permissionService.hasPermission(permissionService.Permission.medium_group_edit)"
                                     (click)="removeAdSpace(medium, marker)">
                                  <sb-icon icon="trash"></sb-icon>
                                </div>
                              </td>
                            </tr>
                          </ng-container>
                          <ng-container *ngIf="medium?.defaultMarkers?.length === 0">
                            <tr>
                              <td><i>{{ 'lang.mediumGroupEdit.noDefaultAdspaces' | translate }}</i></td>
                            </tr>
                          </ng-container>
                          </tbody>
                        </table>
                      </ng-scrollbar>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-scrollbar>
    </div>
  </div>
</div>
<ng-container *sbPageAction>
  <sb-button *ngIf="!isInModalContext" ngbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top"
             container="body"
             classes="btn-default actionButtonMinWidth" (click)="refreshFromServer()" [disabled]="loading"
             [loading]="loading">
    <sb-icon icon="refresh"></sb-icon>
  </sb-button>
  <sb-button
    *ngIf="permissionService.hasPermission(permissionService.Permission.medium_group_edit) && permissionService.hasPermission(permissionService.Permission.medium_list)"
    (click)="addNewMotiveToGroup()"
    classes="btn-primary btn-sm btn-wide">{{
      'lang.mediumGroupEdit.addNewMotive'
        | translate
    }}
  </sb-button>
</ng-container>
